import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DxDataGridModule, DxFormModule, DxTemplateModule} from 'devextreme-angular';
import {FilterConfig, GridPageComponent} from "../../../../common/grid-page.component";
import {StorageUnitBinHistoryDto, StorageUnitStatus} from "@services";
import EnumUtils from "../../../../../shared/enum-utils";
import {CapitalCasePipe} from "../../../../../pipes/capital-case.pipe";

@Component({
    selector: 'app-storage-unit-history',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        CapitalCasePipe
    ],
    templateUrl: './storage-unit-history.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 200px);
        }`
    ]
})
export class StorageUnitHistoryComponent extends GridPageComponent<StorageUnitBinHistoryDto> {
    @Input() historyData: any[] = [];
    statusOptions = EnumUtils.getEnumOptions(StorageUnitStatus);

    constructor() {
        super();
        this.init(StorageUnitBinHistoryDto);
    }

    protected override exportName: string = "StorageUnitHistory";

    protected override filterConfig: FilterConfig[] = [
        {field: 'binNumber', op: 'contains'},
        {field: 'storageTypeCode', op: 'contains'},
        {field: 'status', op: '='},
        {field: 'zone', op: 'contains'},
        {field: 'duration', op: '>='},
        {field: 'lastModified', op: '>='}
    ];

    protected getStatusBadgeClass(status: StorageUnitStatus): string {
        return EnumUtils.getStorageUnitStatusBadgeClass(status);
    }
}

